import { Button } from '@cian/ui-kit';
import { plural } from '@cian/utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackRemoveConfirm, trackRemoveFromFolder } from './tracking';
import { ModalConfirm } from '../../../components/ModalConfirm';
import { useSelectedEntityIds } from '../../../hooks/favoriteEntities/useSelectedEntityIds';
import { useFavoritesUxfeedbackCampaign } from '../../../hooks/uxfeedback';
import { selectResults, selectSelectedProducts } from '../../../selectors';
import { selectSelectedFolder } from '../../../selectors/folders';
import { removeByIds, removeOffersFromFolder } from '../../../thunk/favorites';

interface IProps {
  entityId?: number;
  onClose(): void;
}

export function ModalConfirmRemoveFromFolderContainer({ entityId, onClose }: IProps) {
  const dispatch = useDispatch();
  const selectedProducts = useSelector(selectSelectedProducts);
  const selectedFolder = useSelector(selectSelectedFolder);
  const offerIds = useSelectedEntityIds(entityId);
  const { favoriteEntities } = useSelector(selectResults);
  const count = entityId ? 1 : selectedProducts.length;
  const { sendFavoritesUxfeedbackCampaign } = useFavoritesUxfeedbackCampaign();

  const handleRemoveFromFolder = () => {
    if (selectedFolder) {
      trackRemoveFromFolder(favoriteEntities);
      dispatch(removeOffersFromFolder(offerIds, selectedFolder.id));
    }

    onClose();
    sendFavoritesUxfeedbackCampaign();
  };

  const handleRemoveFromFavorites = () => {
    trackRemoveConfirm(selectedProducts);
    dispatch(removeByIds(entityId));
    onClose();
    sendFavoritesUxfeedbackCampaign();
  };

  const confirmText = `Удалить ${!entityId ? count + ' ' : ''}${plural(count, [
    'объявление',
    'объявления',
    'объявлений',
  ])}`;

  return (
    <ModalConfirm
      text={confirmText}
      footer={
        <>
          <Button size="XS" theme="fill_white_primary" onClick={handleRemoveFromFavorites}>
            Удалить из избранного
          </Button>
          <Button size="XS" onClick={handleRemoveFromFolder}>
            Удалить из подборки
          </Button>
        </>
      }
      onClose={onClose}
      isVisible={true}
    >
      <p>Удалить только из этой подборки или из всего избранного?</p>
    </ModalConfirm>
  );
}
